import { Model, Store, Casts } from 'store/Base';
import { observable } from 'mobx';
import { Project } from 'store/Project';

export const SPRINT_STATUS_PLANNING = 'planning';
export const SPRINT_STATUS_ACTIVE = 'active';
export const SPRINT_STATUS_COMPLETED = 'completed';
export const SPRINT_STATUS_CANCELLED = 'cancelled';

export const SPRINT_STATUSES = [
    SPRINT_STATUS_PLANNING,
    SPRINT_STATUS_ACTIVE,
    SPRINT_STATUS_COMPLETED,
    SPRINT_STATUS_CANCELLED,
];

export class Sprint extends Model {
    static backendResourceName = 'sprint';

    @observable id = null;
    @observable project = this.relation(Project);
    @observable name = '';
    @observable startDate = null;
    @observable endDate = null;
    @observable status = SPRINT_STATUS_PLANNING;
    @observable goals = '';
    @observable order = 0;

    casts() {
        return {
            startDate: Casts.date,
            endDate: Casts.date,
        };
    }
}

export class SprintStore extends Store {
    Model = Sprint;
    static backendResourceName = 'sprint';
}
